import { ZodiacCapricornIcon } from './ZodiacCapricornIcon';

/**
 * author: Michael Richins
 * id 6310BE95-A7A4-4A4C-A478-059DCA6C4E0B
 * name zodiac-capricorn
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zodiac-capricorn.svg
 * tags
 */
export const HoroscopeCapricornIcon = ZodiacCapricornIcon;
export default HoroscopeCapricornIcon